import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Gallery } from "../components/Gallery";
import { TapDemo } from "../components/TapDemo";
import { Steps } from "../components/Steps";
import { Pricing } from "../components/Pricing";
import { Placement } from "../components/Placement";
import { PortalPlans } from "../components/PortalPlans";
import { Trust } from "../components/Trust";
import { ProcessTimeline } from "../components/ProcessTimeline";
import { FinalCta } from "../components/FinalCta";
import { Benefits } from "../components/Benefits";
import { Faq } from "../components/Faq";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-white" data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Gallery />
      <TapDemo />
      <Steps />
      <Pricing />
      <Placement />
      <PortalPlans />
      <Trust />
      <ProcessTimeline />
      <FinalCta />
      <Benefits />
      <Faq />
      <Footer />
    </div>
  );
}
